// import { doc, getFirestore, onSnapshot, updateDoc } from 'firebase/firestore'
import dayjs from 'dayjs';
import { getAuth } from 'firebase/auth';
const prefix = 'wordle_' + dayjs().format('YYYYMMDD');
// let docRef = null
const useLocalStorage = (customPrefix) => {
    var _a;
    const userId = ((_a = getAuth().currentUser) === null || _a === void 0 ? void 0 : _a.uid) || '';
    // const db = getFirestore()
    // if (!docRef) {
    //   const docRef = doc(db, 'users', userId)
    //   onSnapshot(docRef, (snap) => {
    //     console.log(snap)
    //   })
    // }
    const add = (property, value, store) => {
        // const docSnap = await getDoc(docRef)
        // console.log(docRef)
        // if(docSnap.exists() && store)
        //   await updateDoc(docRef, { [property]: value})
        return localStorage.setItem(`${customPrefix || prefix}_${property}_${userId}`, value);
    };
    const get = (property) => {
        return localStorage.getItem(`${customPrefix || prefix}_${property}_${userId}`);
    };
    const remove = async (property) => {
        return localStorage.removeItem(`${customPrefix || prefix}_${property}_${userId}`);
    };
    return {
        add,
        get,
        remove,
    };
};
export default useLocalStorage;
